import { css, SerializedStyles } from '@emotion/react';

import { Theme } from '@shipengine/giger-theme';

export const getShipmentRowServicesCellStyles = (theme: Theme): SerializedStyles =>
    css({
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
        order: -1,
        alignItems: 'baseline',

        [theme.mediaQuery('tablet')]: {
            alignItems: 'start',
            justifyContent: 'normal',
            order: 'unset',
        },
    });

export const getServiceStyles = (theme: Theme): SerializedStyles =>
    css({
        fontWeight: theme.typography.fontWeight.bold,
        display: 'flex',
        flexShrink: 1,
        alignItems: 'center',

        [theme.mediaQuery('tablet')]: {
            display: 'block',
            fontWeight: theme.typography.fontWeight.semibold,
        },
    });

const getImageStyles = (theme: Theme) => ({
    height: 24,
    width: 24,
    marginRight: theme.spacing(),

    [theme.mediaQuery('tablet')]: {
        display: 'none',
    },
});

export const getCarrierLogoStyles = (theme: Theme): SerializedStyles =>
    css({
        ...getImageStyles(theme),
    });

export const getNoServiceIconStyles = (theme: Theme): SerializedStyles =>
    css({
        ...getImageStyles(theme),
        color: theme.palette.gray.light,
        backgroundColor: theme.palette.gray.ultraLight,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.borderRadius.S,
    });

export const getSpecialServiceStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'inline-flex',
        alignItems: 'center',
        marginRight: theme.spacing(0.5),
    });

export const getContractIconStyles = (theme: Theme): SerializedStyles =>
    css({
        marginRight: theme.spacing(0.5),
        color: theme.palette.alert.main,
    });

export const getContractTextStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'none',

        [theme.mediaQuery('tablet')]: {
            display: 'block',
        },
    });
